import { render, staticRenderFns } from "./PgaTechAreaDetails.vue?vue&type=template&id=0aabd4cb&"
import script from "./PgaTechAreaDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaTechAreaDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDivider,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aabd4cb')) {
      api.createRecord('0aabd4cb', component.options)
    } else {
      api.reload('0aabd4cb', component.options)
    }
    module.hot.accept("./PgaTechAreaDetails.vue?vue&type=template&id=0aabd4cb&", function () {
      api.rerender('0aabd4cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/TechAreas/Components/PgaTechAreaDetails.vue"
export default component.exports